import React, { useCallback } from 'react';
import {
  FaLinkedin,
  FaSkype,
  FaGithub,
  FaWhatsapp,
  FaTwitter,
} from 'react-icons/fa';
import patternImg from '../../assets/images/pattern.png';
import liazulImg from '../../assets/images/liazul.png';
import Particles from 'react-particles';
import { loadFull } from 'tsparticles';
import { Cursor, useTypewriter } from 'react-simple-typewriter';

const Hero = ({ isMoon }) => {
  const particlesInit = useCallback(async (engine) => {
    // console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    // await console.log(container);
  }, []);

  const words = [
    'MERN Stack Web Developer',
    'React Developer',
    'JavaScript Developer',
  ];
  const { text } = useTypewriter({
    words,
    loop: 0, // Infinit
  });

  return (
    <section
      id="home"
      className="relative overflow-hidden bg-light-blue dark:bg-light-black"
    >
      {/* Particles start */}
      {!isMoon ? (
        <div className="absolute">
          <Particles
            height="100vh"
            width="100vw"
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
              fpsLimit: 60,
              fullScreen: {
                enable: false,
                zIndex: 0,
              },
              interactivity: {
                detectsOn: 'canvas',
                events: {
                  onClick: {
                    enable: false,
                    mode: 'push',
                  },
                  onHover: {
                    enable: false,
                    mode: 'repulse',
                  },
                  resize: true,
                },
                modes: {
                  bubble: {
                    distance: 400,
                    duration: 2,
                    opacity: 0.8,
                    size: 40,
                  },
                  push: {
                    quantity: 4,
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4,
                  },
                },
              },
              particles: {
                color: {
                  value: '#fff',
                },
                links: {
                  color: '#fff',
                  distance: 150,
                  enable: false,
                  opacity: 0.1,
                  width: 1,
                },
                collisions: {
                  enable: false,
                },
                move: {
                  direction: 'none',
                  enable: true,
                  outMode: 'bounce',
                  random: false,
                  speed: 0.2,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    value_area: 800,
                  },
                  value: 20,
                },
                opacity: {
                  value: 0.5,
                },
                shape: {
                  type: ['star'],
                },
                size: {
                  random: true,
                  value: 5,
                },
              },
              detectRetina: true,
            }}
          />
        </div>
      ) : (
        <div className="absolute">
          <Particles
            height="100vh"
            width="100vw"
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
              fpsLimit: 60,
              fullScreen: {
                enable: false,
                zIndex: 0,
              },
              interactivity: {
                detectsOn: 'canvas',
                events: {
                  onClick: {
                    enable: false,
                    mode: 'push',
                  },
                  onHover: {
                    enable: false,
                    mode: 'repulse',
                  },
                  resize: true,
                },
                modes: {
                  bubble: {
                    distance: 400,
                    duration: 2,
                    opacity: 0.8,
                    size: 40,
                  },
                  push: {
                    quantity: 4,
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4,
                  },
                },
              },
              particles: {
                color: {
                  value: ['#ff7979', '#badc58', '#6c6ce5'],
                },
                links: {
                  color: '#fff',
                  distance: 150,
                  enable: true,
                  opacity: 0.1,
                  width: 1,
                },
                collisions: {
                  enable: false,
                },
                move: {
                  direction: 'none',
                  enable: true,
                  outMode: 'bounce',
                  random: false,
                  speed: 0.3,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    value_area: 800,
                  },
                  value: 10,
                },
                opacity: {
                  value: 0.6,
                },
                shape: {
                  type: ['triangle', 'circle', 'edge'],
                  // stroke: {
                  //   width: 1.5,
                  //   color: {
                  //     value: ['#0fa573', '#ff7979', '#badc58', '#6c6ce5'],
                  //   },
                  // },
                  polygon: {
                    nb_sides: 6,
                  },
                },
                size: {
                  random: true,
                  value: 16,
                  // anim: {
                  //   enable: true,
                  //   speed: 20,
                  //   size_min: 10,
                  //   sync: false
                  // }
                },
              },
              detectRetina: true,
            }}
          />
        </div>
      )}
      {/* Particles start */}
      <div className="max-w-screen-xl mx-auto px-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="order-2 md:order-1 flex items-center justify-center md:justify-start">
            <div>
              <div
                className="info"
                data-aos="fade-down"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="2000"
              >
                <h1
                  className="text-[40px] sm:text-[50px] font-black mt-24 md:mt-0 mb-2 dark:text-white"
                  style={{ fontFamily: " 'Dancing Script', cursive" }}
                >
                  Liazul Islam
                </h1>
                <p className="text-[#ff5500] dark:text-sky-500 mb-5">
                  <span>{text}</span>
                  <Cursor />
                </p>
                <p className="dark:text-white text-[18px]">
                  Highly motivated, ambitious, and creative person who can make
                  you happy to develop an amazing website at an affordable
                  price.
                </p>
                <a
                  className="py-[10px] px-[18px] bg-black text-white rounded inline-block my-8 hover:bg-orange transform translate duration-700 dark:bg-white dark:text-black dark:hover:bg-orange dark:hover:text-white font-medium"
                  href="https://drive.google.com/file/d/125N6LPDZLdIvsoy8YvAhje2so-x2deZh/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Resume
                </a>
              </div>
              <div
                className="social-links flex text-3xl mt-10 md:mt-[100px] pb-5 md:pb-0"
                data-aos="fade-right"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="2000"
              >
                <a
                  className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                  href="https://www.linkedin.com/in/liazul"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin />
                </a>
                <a
                  className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                  href="https://join.skype.com/invite/o9hkLAsJNG1D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaSkype />
                </a>
                <a
                  className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                  href="https://github.com/mohammadliazul"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub />
                </a>
                <a
                  className="hover:text-orange transform translate duration-500 mr-5 dark:text-white dark:hover:text-orange"
                  href="https://wa.me/+8801797570726"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>
                <a
                  className="hover:text-orange transform translate duration-500 dark:text-white dark:hover:text-orange"
                  href="https://twitter.com/liazul_islam"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter />
                </a>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2 hidden sm:block ">
            <div
              className="img-box h-screen relative"
              data-aos="fade-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                className="back-img h-[65%] w-fit z-1 absolute inset-x-0 bottom-[48px]"
                src={patternImg}
                alt="back-img"
              />
              <img
                className="main-img h-[80%] w-fit z-40 absolute inset-x-0 bottom-0"
                src={liazulImg}
                alt="main-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
